import { LogLevel } from "@azure/msal-browser";
import { clearStunMStorage } from "./utils/workflowUtils";

/**
 * Environment helpers
 */
const getClientId = () => process.env.REACT_APP_AZURE_AD_CLIENT_ID;
const getTenantId = () => process.env.REACT_APP_AZURE_AD_TANENT_ID;
const getCurrentOrigin = () => window.location.origin;

export const msalConfig = {
    auth: {
        clientId: getClientId(),

        authority: `https://login.microsoftonline.com/${getTenantId()}`,

        /**
         * Popup flow does NOT require /auth callback.
         */
        redirectUri: getCurrentOrigin(),

        postLogoutRedirectUri: `${getCurrentOrigin()}/orgpasswordlogin`,

        navigateToLoginRequestUrl: false,
    },

    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },

    system: {
        loggerOptions: {
            loggerCallback(level, message, containsPii) {

                if (containsPii) return;

                switch (level) {

                    case LogLevel.Error:
                        console.error("[MSAL]", message);
                        break;

                    case LogLevel.Warning:
                        console.warn("[MSAL]", message);
                        break;

                    case LogLevel.Info:
                        console.info("[MSAL]", message);
                        break;

                    case LogLevel.Verbose:
                        console.debug("[MSAL]", message);
                        break;

                    default:
                        console.log("[MSAL]", message);
                }
            },

            piiLoggingEnabled: false,

        logLevel: LogLevel.Warning
        }
    }
};

/**
 * Keep login scopes minimal.
 * Additional scopes should be requested later.
 */
export const loginRequest = {
    scopes: [
        process.env.REACT_APP_AZURE_AD_API_SCOPE
    ].filter(Boolean),
    prompt: "select_account"
};

export const logoutAzure = async (
    msalInstance,
    setIsLoggedIn,
    setIsApproverLoggedIn,
    setUser_type
) => {

    try {

        setIsLoggedIn(false);
        setIsApproverLoggedIn(false);
        setUser_type(null);

        clearStunMStorage();

        await msalInstance.logoutPopup({
            mainWindowRedirectUri:
                `${getCurrentOrigin()}/orgpasswordlogin`
        });

    }
    catch (error) {

        console.error("Logout Error");

        console.error(error);

        window.location.href =
            `${getCurrentOrigin()}/orgpasswordlogin`;

    }

};
